import gql from 'graphql-tag';

export const graphFilterOptions = gql `
query ($first: Int, $offset: Int, $filter: GroupFilter, $order: [OrderByInput]) {
  filterGroup(first: $first, filter: $filter, order: $order, offset: $offset) {
    name
    id
    fields : searchFields {
      id
      name
      typeId
      title
      ... on MultiSelectField {
        options: searchOptions {
          value
          id
        }
      }
      ... on SingleSelectField {
        options: searchOptions {
          value
          id
        }
      }
    }
  }
}`;
export const graphFilterOptionsNewGroup = gql `
query ($first: Int, $offset: Int, $filter: CategoryFilter, $order: [OrderByInput]) {
  filterCategory(first: $first, offset: $offset, filter: $filter, order: $order) {
    name
    id
    fields: filterFields {
      typeId
      id
      name
      title
      ... on SingleSelectField {
        options: searchOptions {
          value
          id
          type
        }
      }
      ... on MultiSelectField {
        options: searchOptions {
          value
          id
          type
        }
      }
    }
  }
}`;

